import * as paginator from '../plugins/mmmPaginator.js';

document.addEventListener(`DOMContentLoaded`, () => {
    const container = document.querySelector(`ul[aria-live="polite"][aria-atomic="true"]`);
    const articleListItems = container.querySelectorAll(`[data-item="article"]`);
    const items = [];

    articleListItems.forEach(liItem => {
        items.push({liContent: liItem.innerHTML});
    });

    container.innerHTML = null;

    const paginatorOptions = {
        items: items,
        perPage: 4,
        container: container,
        pager: document.querySelector(`ul.pagination`),
        renderItem: (item) => {
            return `
                <li data-item="article">
                    ${item.liContent}
                </li>
            `
        },
        renderPageButton: (page, isActive) => {
            return `
                <li class="page-item${isActive ? ' active' : ''}" data-page="${page}">
                    <a class="page-link h4" href="#"${isActive ? ' aria-current="page"' : ''}>
                        ${isActive ? '<span class="sr-only">Pagina </span>' : ''}${page}
                    </a>
                </li>
            `
        },
        renderPrevButton: () => {
            return `
                <li class="page-item" data-prev>
                    <a class="icon-chevron-left pagin-arrow" href="#">
                        <span class="sr-only">Pagina precedente</span>
                    </a>
                </li>
            `
        },
        renderNextButton: () => {
            return `
                <li class="page-item" data-next>
                    <a class="icon-chevron-right pagin-arrow" href="#">
                        <span class="sr-only">Pagina successiva</span>
                    </a>
                </li>
            `
        },
        siblingCount: 4,
    }

    console.log(container); // non deve essere null
    console.log(items); // almeno 1 elemento
    console.log(typeof paginator.initialize); // deve essere "function"
    console.log(typeof paginatorOptions.renderItem); // deve essere "function"
    console.log(typeof paginatorOptions.renderPrevButton); // deve essere "function"
    console.log(typeof paginatorOptions.renderNextButton); // deve essere "function"

    paginator.initialize(paginatorOptions);
});